import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import LocationSection from './components/LocationSection';
import ServicesSection from '../../home/components/ServicesSection';
import BenefitsSection from '../../home/components/BenefitsSection';
import TintShadesSection from '../../home/components/TintShadesSection';
import TestimonialsSection from '../../home/components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from '../../home/components/CTASection';
import { useSEO, generateLocalBusinessSchema, generateWebPageSchema } from '../../../utils/seo';
import { useEffect } from 'react';

export default function OwingsMillsPage() {
  // Apply localized SEO metadata with geo-tags
  useSEO({
    title: 'Owings Mills Window Tinting Services - Premium Ceramic Tint - U.B.K Window Tint',
    description:
      'Professional window tinting services in Owings Mills, Maryland. Expert ceramic tint installation, mobile service, commercial tinting, vehicle decals, and headlight tinting. Serving Owings Mills, Reisterstown, Pikesville. Lifetime warranty. Call (443) 800-0348.',
    keywords:
      'window tinting Owings Mills, ceramic tint Owings Mills MD, mobile tinting Owings Mills, commercial tinting Owings Mills, vehicle decals Owings Mills',
    canonical: '/locations/owings-mills',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          ...generateLocalBusinessSchema(),
          '@type': 'AutoRepair',
          name: 'U.B.K Window Tint - Owings Mills',
          address: {
            '@type': 'PostalAddress',
            streetAddress: '',
            addressLocality: 'Owings Mills',
            addressRegion: 'MD',
            postalCode: '21117',
            addressCountry: 'US',
          },
          geo: {
            '@type': 'GeoCoordinates',
            latitude: '39.4193',
            longitude: '-76.7805',
          },
          areaServed: {
            '@type': 'City',
            name: 'Owings Mills',
            '@id': 'https://en.wikipedia.org/wiki/Owings_Mills,_Maryland',
          },
        },
        generateWebPageSchema(
          'Owings Mills Window Tinting Services - Premium Ceramic Tint - U.B.K Window Tint',
          'Professional window tinting services in Owings Mills, Maryland with lifetime warranty and same-day service.',
          '/locations/owings-mills'
        ),
      ],
    },
  });

  useEffect(() => {
    // Add geo meta tags for local SEO
    const geoTags = [
      { name: 'geo.region', content: 'US-MD' },
      { name: 'geo.placename', content: 'Owings Mills' },
      { name: 'geo.position', content: '39.4193;-76.7805' },
      { name: 'ICBM', content: '39.4193, -76.7805' },
    ];

    geoTags.forEach(tag => {
      let meta = document.querySelector(`meta[name="${tag.name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', tag.name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', tag.content);
    });
  }, []);

  return (
    <div className="min-h-screen">
      <Navigation />
      <header>
        <h1 className="sr-only">
          Owings Mills Window Tinting Services - Premium Ceramic Tint - U.B.K Window Tint
        </h1>
      </header>
      <main>
        <HeroSection />
        <LocationSection />
        <ServicesSection />
        <BenefitsSection />
        <TintShadesSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
